import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import authService from '../services/authService';

const ProtectedRoute = () => {
  const isAuthenticated = authService.isAuthenticated();
  
  // Si l'utilisateur n'est pas authentifié, rediriger vers la page de connexion
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Si l'utilisateur est authentifié, afficher les routes enfants
  return <Outlet />;
};

export default ProtectedRoute;